import { render, staticRenderFns } from "./CreateCloudaccount.vue?vue&type=template&id=2234a5fe"
import script from "./CreateCloudaccount.vue?vue&type=script&lang=js"
export * from "./CreateCloudaccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports